module.exports = __webpack_public_path__ + "static/img/scanExpressCode.7a0c66b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/mailBox/images/scanExpressCode.jpg
// module id = 9n5+
// module chunks = 1